import React from 'react';
import PropTypes from 'prop-types';
import { callTranscriptTurns } from '../../utils/callTranscript';
import T from '../common/T';

const CallTranscript = ({ segments, text }) => {
  const turns = callTranscriptTurns(segments, text);
  if (!turns.length) return <p><T>Gesprächsverlauf noch nicht verfügbar.</T></p>;
  return <div aria-label="Gesprächsverlauf">
    {turns.map((turn, index) => <p key={`${turn.key}-${index}`} data-speaker={turn.label || undefined}
      style={{ margin: '0 0 16px', whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
      {turn.label && <strong>{turn.label}: </strong>}{turn.text}
    </p>)}
  </div>;
};

CallTranscript.propTypes = {
  text: PropTypes.string,
  segments: PropTypes.arrayOf(PropTypes.shape({
    speaker: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    speaker_label: PropTypes.string,
    text: PropTypes.string,
  })),
};

export default CallTranscript;
